var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../../../js/filters/nunjucks-config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["modal/user/create/login-hide-email-subscription.j2"] = require( "modal/user/create/login-hide-email-subscription.j2" );
dependencies["modal/user/create/login-create-email-subscription.j2"] = require( "modal/user/create/login-create-email-subscription.j2" );




var shim = require("/jh/workspace/MonoWeb-Build-Release/monoweb/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["core/templates/modal/user/create/options.j2"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
output += "\n";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"featureConfigs") && runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"featureConfigs")),"user-authorization-modal-feature")) {
output += "\n    ";
var t_1;
t_1 = runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"featureConfigs")),"user-authorization-modal-feature");
frame.set("emailFeatureConfig", t_1, true);
if(frame.topLevel) {
context.setVariable("emailFeatureConfig", t_1);
}
if(frame.topLevel) {
context.addExport("emailFeatureConfig", t_1);
}
output += "\n        ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "emailFeatureConfig")),"showEmailSignUpAtAccountCreate")) {
output += "\n            <div class=\"c-form__field\">\n                <ul class=\"c-form-adjacent\">\n                    ";
if(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"userLocation")),"isUS") && runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"contextPath") == "/") {
output += "\n                        ";
env.getTemplate("modal/user/create/login-hide-email-subscription.j2", false, "core/templates/modal/user/create/options.j2", null, function(t_4,t_2) {
if(t_4) { cb(t_4); return; }
t_2.render(context.getVariables(), frame, function(t_5,t_3) {
if(t_5) { cb(t_5); return; }
output += t_3
output += "\n                    ";
})});
}
else {
output += "\n                        ";
env.getTemplate("modal/user/create/login-create-email-subscription.j2", false, "core/templates/modal/user/create/options.j2", null, function(t_8,t_6) {
if(t_8) { cb(t_8); return; }
t_6.render(context.getVariables(), frame, function(t_9,t_7) {
if(t_9) { cb(t_9); return; }
output += t_7
output += "\n                    ";
})});
}
output += "\n                </ul>\n            </div>\n\n        ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "emailFeatureConfig")),"showGenderCaptureForEmailSignUp")) {
output += "\n            <div class=\"c-form__field\">\n                <label for=\"login-email-subscription-gender\" class=\"c-modal-form__label\" data-email-subscription-gender>\n                    ";
output += runtime.suppressValue((lineno = 17, colno = 22, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["modal-create_subscription_gender-label",runtime.makeKeywordArgs({"state": runtime.contextOrFrameLookup(context, frame, "core")})])), env.opts.autoescape);
output += "\n                </label>\n                <select id=\"login-email-subscription-gender\" name=\"emailSubscriptionGender\" class=\"c-form__select\" data-qa-email-subscription-gender-dropdown>\n                    <option value=\"UNKNOWN\" selected>\n                        ";
output += runtime.suppressValue((lineno = 21, colno = 26, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["modal-create_subscription_gender-unknown",runtime.makeKeywordArgs({"state": runtime.contextOrFrameLookup(context, frame, "core")})])), env.opts.autoescape);
output += "\n                    </option>\n                    <option value=\"MALE\">\n                        ";
output += runtime.suppressValue((lineno = 24, colno = 26, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["modal-create_subscription_gender-male",runtime.makeKeywordArgs({"state": runtime.contextOrFrameLookup(context, frame, "core")})])), env.opts.autoescape);
output += "\n                    </option>\n                    <option value=\"FEMALE\">\n                        ";
output += runtime.suppressValue((lineno = 27, colno = 26, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["modal-create_subscription_gender-female",runtime.makeKeywordArgs({"state": runtime.contextOrFrameLookup(context, frame, "core")})])), env.opts.autoescape);
output += "\n                    </option>\n                </select>\n            </div>\n        ";
;
}
output += "\n\n        <input type=\"hidden\" id=\"login-email-subscription-source\" name=\"emailSubscriptionSource\" value=\"";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "emailFeatureConfig")),"emailSubscriptionSource"), env.opts.autoescape);
output += "\" />\n    ";
;
}
output += "\n";
;
}
output += "\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["core/templates/modal/user/create/options.j2"] , dependencies)